import { Builder } from '@builder.io/react';
import { BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES } from '../BuilderComponentsName';
import { S10PressReleasePostSection } from '../components/interactive-sections/S10PressReleasePost';
import { backgroundGradientOptions, textColorOptionsLimited } from '../utils/builderColorOptions';
import { getBackgroundColorInput, getBackgroundGradientInput, getPaddingInputs } from '../utils/builderSharedInputs';

Builder.registerComponent(S10PressReleasePostSection, {
  name: BUILDER_INTERACTIVE_SECTION_COMPONENTS_NAMES.S10PressReleasePost,
  friendlyName: 'S10 Press Release Post',
  inputs: [
    {
      name: 'headline',
      type: 'string',
      required: true,
      defaultValue: 'Milan Laser Hair Removal Bares Its Brand at Miami Swim Week® The Shows',
      friendlyName: 'Headline',
      helperText: 'Main headline for the press release',
    },
    {
      name: 'headlineColor',
      type: 'string',
      defaultValue: 'Blue',
      enum: textColorOptionsLimited,
      friendlyName: 'Headline Color',
      helperText: 'Color for the headline text',
    },
    {
      name: 'date',
      type: 'date',
      required: true,
      defaultValue: 'July 8, 2024',
      friendlyName: 'Date',
      helperText: 'Publication date of the press release',
    },
    {
      name: 'city',
      type: 'string',
      required: true,
      defaultValue: 'Omaha, NE',
      friendlyName: 'City',
      helperText: 'City where the press release is published from',
    },
    {
      name: 'content',
      type: 'richText',
      friendlyName: 'Press Release Content',
      helperText: 'Use the rich text editor to format your press release content with paragraphs, bold text, links, etc. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
      defaultValue: `<p>Nothing complements a swimsuit quite like smooth skin. That's why Milan Laser Hair Removal was a natural pick to sponsor Miami Swim Week® The Shows, the largest global swim festival with over 50 events, 100+ designers, and 20+ satellite locations.</p>

<p>Bold, vibrant colors, artful innovations, and captivating cut-outs dominated the runways during the four-day event that featured top and emerging global swimwear designers. To celebrate, Milan Laser hosted exclusive events and giveaways in its Bare Bungalow throughout the event.</p>

<p>Influencers and fashion editors dropped by Milan's Bare Bungalow for photo ops, meet and greets with brand ambassadors, and a chance to win free unlimited laser hair removal for life. Models got to pop in between shows, and attendees cooled down while learning about laser hair removal and scoring some coveted Milan swag.</p>

<p>Milan Laser was in the spotlight during the event's Sunset Soiree as well as NEXT Impact Panel, "Transforming Your Brand by Creating a Culture Around Wellness and Values", featuring Milan's Chief Marketing Officer Sheila Ullery.</p>

<p>Milan Laser is the go-to destination for anyone wanting the best swimsuit accessory — hair-free skin! Plus, every purchase includes unlimited treatments for life with no touch-up fees, ever. With {{clinicCount}} locations nationwide, its expert medically-backed team is dedicated to providing safe, effective treatments for all skin tones.</p>

<p>"At Milan Laser, we help our clients become the most confident versions of themselves," said Ullery. "Milan is excited to be part of an event that lets everyone experience beauty and confidence."</p>

<p>Core to Milan Laser's brand, Miami Swim Week® celebrates diversity and inclusion. All body types and backgrounds are encouraged to look and feel their best with nothing standing in their way—especially not unwanted hair!</p>`
    },
    {
      name: 'contentColor',
      type: 'string',
      defaultValue: 'Navy',
      enum: textColorOptionsLimited,
      friendlyName: 'Content Color',
      helperText: 'Color for the main content text',
    },
    {
      name: 'footnoteHeading',
      type: 'string',
      defaultValue: 'About Milan Laser Hair Removal',
      friendlyName: 'Footnote Heading',
      helperText: 'Heading for the footnote section',
    },
    {
      name: 'footnote',
      type: 'longText',
      defaultValue: 'Founded in 2012 by two board-certified medical doctors in Omaha, Nebraska, Milan Laser Hair Removal is the nation\'s largest laser hair removal provider. Milan Laser is a premier employer with {{clinicCount}} clinics in {{stateCount}} states and 2,000+ employees nationally. Laser hair removal is all Milan Laser does, performing more than {{treatmentsPerMonth}} treatments each month. Milan Laser provides life-long results for all genders and skin tones in a safe, judgment-free environment. All treatments are performed by highly trained medical professionals with top-notch medical protocols. ',
      friendlyName: 'Footnote',
      helperText: 'Footnote content, typically company information or disclaimers. Available variables: {{clinicCount}}, {{totalReviews}}, {{stateCount}}, {{treatmentsPerMonth}}',
    },
    {
      name: 'firstName',
      type: 'string',
      required: true,
      defaultValue: 'First Name',
      friendlyName: 'Author First Name',
      helperText: 'First name of the press release author',
    },
    {
      name: 'lastName',
      type: 'string',
      required: true,
      defaultValue: 'Last Name',
      friendlyName: 'Author Last Name',
      helperText: 'Last name of the press release author',
    },
    {
      name: 'authorPosition',
      type: 'string',
      required: true,
      defaultValue: 'Job Title',
      friendlyName: 'Author Position',
      helperText: 'Job title or position of the press release author',
    },
    {
      name: 'email',
      type: 'string',
      required: true,
      defaultValue: 'press@milanlaser.com',
      friendlyName: 'Contact Email',
      helperText: 'Contact email address for press inquiries',
    },
    ...getBackgroundColorInput({
      defaultValue: 'White',
    }),
    ...getBackgroundGradientInput({
      backgroundGradientName: 'backgroundGradient',
      backgroundGradientList: backgroundGradientOptions,
    }),
    {
      name: 'backgroundImage',
      type: 'file',
      allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp', 'gif', 'svg'],
      friendlyName: 'Background Image',
      helperText: 'Upload a background image or provide an image URL (optional)',
    },
    ...getPaddingInputs({
      desktopTop: 'large',
      desktopBottom: 'large',
      mobileTop: 'small',
      mobileBottom: 'small',
    }),
  ],
});
